<div class="mt-6" *transloco="let t">
  <ng-container>
    <div class="mb-4">
      <app-metric-selector
        [availableMetrics]="chartMetrics()"
        [data]="globalData()"
        [previousPeriodData]="previousPeriodGlobalData()"
        (selectedMetricsChange)="selectMetrics($event)"
        [localStorageKey]="metricsStorageKey()"
      ></app-metric-selector>
    </div>

    @if (!isStatsChartHidden) {
      <app-chart-layout
        withEventAnnotation
        withDateAggregation
        closable
        [allEventAnnotationTypes]="allEventAnnotationTypes()"
        [displayEventAnnotation]="(displayEventAnnotation$ | async) ?? false"
        [disableEventAnnotation]="disableEventAnnotation()"
        (displayEventAnnotationChange)="displayEventAnnotation$.next($event)"
        (closeClicked)="toggleStatsChartDisplay(true)"
        (aggregationChange)="selectAggregation($event)"
      >
        <IChart [config]="chartConfig()" [data]="chartData()" />
      </app-chart-layout>
    }
    <div class="my-3 flex w-full items-center justify-end gap-1">
      <button
        iButton
        variant="secondary"
        [iTooltip]="t('common.restore_default_columns')"
        (click)="restoreDefaultColumns()"
      >
        {{ t("common.restore_columns") }}
      </button>
      <app-export-button
        tooltipValue="{{ t('strategy-detail-stats-modal.export_strategy_csv') }}"
        (export)="exportStrategyStatsCsv()"
      />
      @if (isStatsChartHidden) {
        <button
          iButton
          variant="secondary"
          size="icon-sm"
          [iTooltip]="t('common.show_chart')"
          (click)="toggleStatsChartDisplay(false)"
        >
          <IIcon name="chartLine" />
        </button>
      }
    </div>
    @if (strategy(); as strategy) {
      @if (strategy.campaignType === CampaignType.SB) {
        <div class="mb-6">
          <ITabs [tabs]="SB_TABS" [(activeTab)]="selectedStatsTab" />
        </div>
        <div class="mt-2 h-[30rem]">
          @switch (selectedStatsTab()) {
            @case (0) {
              <app-sb-creative-stats-grid
                #creativeGrid
                [strategy]="strategy"
                [currency]="currency()"
                [locale]="locale()"
              />
            }
            @case (1) {
              <app-strategy-placement-stats-grid
                #tacticPlacementGrid
                [strategy]="strategy"
                [currency]="currency()"
                [locale]="locale()"
              />
            }
          }
        </div>
      } @else if (strategy.campaignType === CampaignType.DSP) {
        <div class="mt-2 h-[30rem]">
          <app-dsp-strategy-stats-grid
            #dspStrategyGrid
            [strategy]="strategy"
            [strategyMetrics]="dspStrategyMetrics()!"
            [currency]="currency()"
            [locale]="locale()"
          />
        </div>
      } @else {
        <div class="mt-2 h-[30rem]">
          <app-strategy-placement-stats-grid
            #tacticPlacementGrid
            [strategy]="strategy"
            [currency]="currency()"
            [locale]="locale()"
          />
        </div>
      }
    }
  </ng-container>
</div>
